export enum CompanyRole {
    DASHBOARD_READ = 'company-dashboard-read',
    ORDERLIST_READ = 'company-orderlist-read',
    ORDERLIST_EDIT = 'company-orderlist-edit',
    STYLES_READ = 'company-styles-read',
    PHOTOGRAPHERS_READ = 'company-photographers-read',
    PHOTOGRAPHERS_EDIT = 'company-photographers-edit',
    TEMPLATES_READ = 'company-templates-read',
    TEMPLATES_EDIT= 'company-templates-read',
    MANAGEMENT_READ = 'company-management-read',
    ACCOUNT_READ = 'company-account-read',
}